import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  user: any = {};

  constructor(private router: Router, private auth: AuthService) { }

  ngOnInit() {
    this.auth.getCurrentUser().then(res => { this.user = res; });
  }

  logout() {
    this.auth.doLogout();
    this.router.navigate(['login']);
  }

}
